import {FaTrash} from "react-icons/fa";
import {FaPencil} from "react-icons/fa6";

export const LIST_HEADERS = ["name", "description", "event_types", "enabled"];

export const ACTIONS_LIST = [
  {label: "Edit", icon: FaPencil, perms: ["change_eventrule"]},
  {label: "Delete", icon: FaTrash, perms: ["delete_eventrule"]},
];

export const PERMS_FOR_ACTIONS = [];
